import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, distinctUntilChanged, share, Subject, takeUntil } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountryService {
  constructor() {}
  private country$ = new BehaviorSubject<string>('');
  private region$ = new BehaviorSubject<any[]>([]);
  private listCountryAssigned$ = new BehaviorSubject<string[]>([]);
  private http = inject(HttpClient);
  private unsubscribe$ = new Subject<void>();

  getCountry() {
    return this.country$.asObservable().pipe(distinctUntilChanged(), share());
  }

  setCountry(countryCode: string) {
    this.country$.next(countryCode);
  }

  getRegion() {
    return this.region$.asObservable().pipe(distinctUntilChanged(), share());
  }

  setRegion(region: any[]) {
    this.region$.next(region);
  }

  getlistCountryAssigned() {
    return this.listCountryAssigned$.asObservable().pipe(distinctUntilChanged(), share());
  }

  setlistCountryAssigned(listCountryAssigned: string[]) {
    this.listCountryAssigned$.next(listCountryAssigned);
  }

  getListRegion(): Promise<any[]> {
    const params = new HttpParams().set('validCountry', true);

    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.BE_API_URL}/regional/regional/country`, { params })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (res: any) => {
            if (res.success) {
              this.setRegion(res.data);
              resolve(res.data);
            } else {
              reject('Region fetch failed');
            }
          },
          error: (err) => {
            console.error(err);
            reject(err);
          },
        });
    });
  }
}
